import { z } from "zod";
import { sessionLinkInputSchema, attachSessionResponseSchema, detachSessionResponseSchema } from "../session-links.js";
import { sessionIdSchema } from "../sessions.js";
import { defineOperation } from "./http.js";
const request = { params: z.object({ sessionId: sessionIdSchema }).strict(), body: sessionLinkInputSchema };
const openapi = {
    description: "Requires the session owner or an organisation admin, source session read access and destination channel access. Explicit sharing grants current channel readers session read access only. Detach revokes only that grant, preserving source task permissions, independent access and runtime activity. No run is created.",
    responseDescription: "Sharing changed, or an idempotent no-op", errors: [400, 401, 403, 404],
};
export const TWIN_SESSION_LINK_OPERATIONS = {
    attachSession: defineOperation({
        operationId: "twin.sessions.attach", method: "POST", path: "/api/twin/sessions/{sessionId}/channels",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: attachSessionResponseSchema },
        sdk: { namespace: "twin", method: "attachTwinSession" }, mcpTool: "twin_session_attach",
        openapi: { ...openapi, summary: "Share a session with channel readers" },
    }),
    detachSession: defineOperation({
        operationId: "twin.sessions.detach", method: "DELETE", path: "/api/twin/sessions/{sessionId}/channels",
        audience: "public", requiredScope: "twin.write", rateClass: "create", request,
        response: { kind: "json", status: 200, schema: detachSessionResponseSchema },
        sdk: { namespace: "twin", method: "detachTwinSession" }, mcpTool: "twin_session_detach",
        openapi: { ...openapi, summary: "Revoke explicit session sharing" },
    }),
};
